import React from 'react';
import './index.css';

const AboutSection = () => {
  return (
    <div className="about-section">
      <div className="about-intro-inner">
        <p className="about-intro-label">Our Philosophy</p>
        <h2 className="about-intro-title">Our Vision & Ethos</h2>
        <p className="about-intro-text">
          At Luxe Unbounded, luxury is not just about opulence — it's about a lifestyle built on shared values, innovative investments, and unforgettable experiences. We invite you to join a community where passion, purpose, and exclusivity intersect, paving the way for a reimagined future in luxury living.
        </p>
      </div>
    </div>
  );
};

export default AboutSection;
